// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-page-container {
  flex-grow: 1;
  margin-top: 61px;
  /*position: relative;*/
}

.map-container {
  display: block;
  height: calc(100vh - 51px);
  position: fixed;
  top: 53px;
  width: 100%;
}

.ev-card-position {
  margin-top: 70vh;
}

.inner-map {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  touch-action: pan-x pan-y;
}

.map-controls-container {
  position: static;
  top: 0;
  right: 0;
  width: 99%;
  height: 88vh;
  pointer-events: all;
}

@media screen and ( max-height: 950px ) {
  .map-controls-container {
  height: 82vh;
  }
}


.graph-container {
  width: 100% !important;
  pointer-events: all;
  z-index: 0;
}

.question-mark-map {
  position: relative;
  float: right;
  bottom: 10vh;
  margin: 5px;
  cursor: pointer;
  width: 100%;
  height: 0px;
  display: grid;
  justify-content: flex-end;
}

.inner-map-squeezed {
  width: 40%;
}

.inner-map-small-screen {
  height: 50%;
}

.content-wrapper {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.content-wrapper-inside {
  position: relative;
}

.content-above {
  width: 33.3%;
  min-height: 40vh;
  padding-right: 20px;
  position: relative;
  /*top: 0.5%;*/
  /*left: 0;*/
  pointer-events: none;
}

.content-below {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.map-page-content {
  margin: 0 auto;
  max-width: 80%;
  position: relative;
  z-index: 1;
  margin-bottom: 10px;
}

.h-full {
  height: 100%;
}

.w-full {
  width: 100%;
}

.rounded-corners {
  border-radius: 25px;
  border: 1px;
}

.rounded-corners-left {
  border-radius: 25px 0 0 25px;
  border: 1px;
}

.rounded-corners-right {
  border-radius: 0 25px 25px 0;
  border: 1px;
}

.text-grey {
  color: gray;
}

.dot {
  height: 25px;
  width: 25px;
  background-color: #d8d8d8;
  border-radius: 50%;
  display: inline-block;
}

.dot-bigger {
  height: 40px;
  width: 40px;
}

.blue-bg {
  background-color: #8084c0;
}

.hidden {
  visibility: hidden;
}

.toggle-service-button {
  position: relative;
  top: 36px;
  left: 36px;
  z-index: 100;
  height: 40px;
  width: 300px;
  border-radius: 7px;
  justify-content: center;
  align-items: center;
}

.popItems {
  display: flex;
  justify-content: space-between;
  margin: 5px;
}

.popLabels {
  display: flex;
  align-content: center;
  align-items: center;
  font: Barlow;
}

.popup-panel {
  position: absolute;
  top: 100px;
  left: 50px;
  z-index: 101;
  width: 300px;
  border: 3px solid green;
  border-radius: 7px;
  background: white;
}

.popup-panel-simulation {
  position: relative;
  z-index: 101;
  width: 300px;
  border: 3px solid green;
  border-radius: 7px;
  background: white;
}

/* .closePopup {
  color: white;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.closePopup:hover {
  opacity: 1;
}

.closePopup:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
} */

.info-card-map {
  width: 50%;
  left: 25%;
  position: absolute;
  bottom: 0;
}

.zoom-right-aligned {
  margin-right: 32% !important;
}

.zoom-controls {
  top: 50px !important;
}

.add-point-active {
  cursor: crosshair;
}

.pointer-on-map {
  cursor: pointer;
}

.popup-button {
  background: #dddddd;
  color: black;
  border-radius: 6px;
}

.legend-div {
  position: relative;
  top: -3vh;
}

.leaflet-right .leaflet-control {
  margin-right: 25px;
}

.leaflet-bottom .leaflet-control {
  margin-bottom: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/css/map.css"],"names":[],"mappings":"AAAA;EAEE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;EACA,YAAY;EACZ;AACF;;;AAGA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".map-page-container {\n  -webkit-flex-grow: 1;\n  flex-grow: 1;\n  margin-top: 61px;\n  /*position: relative;*/\n}\n\n.map-container {\n  display: block;\n  height: calc(100vh - 51px);\n  position: fixed;\n  top: 53px;\n  width: 100%;\n}\n\n.ev-card-position {\n  margin-top: 70vh;\n}\n\n.inner-map {\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  touch-action: pan-x pan-y;\n}\n\n.map-controls-container {\n  position: static;\n  top: 0;\n  right: 0;\n  width: 99%;\n  height: 88vh;\n  pointer-events: all;\n}\n\n@media screen and ( max-height: 950px ) {\n  .map-controls-container {\n  height: 82vh;\n  }\n}\n\n\n.graph-container {\n  width: 100% !important;\n  pointer-events: all;\n  z-index: 0;\n}\n\n.question-mark-map {\n  position: relative;\n  float: right;\n  bottom: 10vh;\n  margin: 5px;\n  cursor: pointer;\n  width: 100%;\n  height: 0px;\n  display: grid;\n  justify-content: flex-end;\n}\n\n.inner-map-squeezed {\n  width: 40%;\n}\n\n.inner-map-small-screen {\n  height: 50%;\n}\n\n.content-wrapper {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n}\n\n.content-wrapper-inside {\n  position: relative;\n}\n\n.content-above {\n  width: 33.3%;\n  min-height: 40vh;\n  padding-right: 20px;\n  position: relative;\n  /*top: 0.5%;*/\n  /*left: 0;*/\n  pointer-events: none;\n}\n\n.content-below {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.map-page-content {\n  margin: 0 auto;\n  max-width: 80%;\n  position: relative;\n  z-index: 1;\n  margin-bottom: 10px;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.rounded-corners {\n  border-radius: 25px;\n  border: 1px;\n}\n\n.rounded-corners-left {\n  border-radius: 25px 0 0 25px;\n  border: 1px;\n}\n\n.rounded-corners-right {\n  border-radius: 0 25px 25px 0;\n  border: 1px;\n}\n\n.text-grey {\n  color: gray;\n}\n\n.dot {\n  height: 25px;\n  width: 25px;\n  background-color: #d8d8d8;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.dot-bigger {\n  height: 40px;\n  width: 40px;\n}\n\n.blue-bg {\n  background-color: #8084c0;\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.toggle-service-button {\n  position: relative;\n  top: 36px;\n  left: 36px;\n  z-index: 100;\n  height: 40px;\n  width: 300px;\n  border-radius: 7px;\n  justify-content: center;\n  align-items: center;\n}\n\n.popItems {\n  display: flex;\n  justify-content: space-between;\n  margin: 5px;\n}\n\n.popLabels {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  font: Barlow;\n}\n\n.popup-panel {\n  position: absolute;\n  top: 100px;\n  left: 50px;\n  z-index: 101;\n  width: 300px;\n  border: 3px solid green;\n  border-radius: 7px;\n  background: white;\n}\n\n.popup-panel-simulation {\n  position: relative;\n  z-index: 101;\n  width: 300px;\n  border: 3px solid green;\n  border-radius: 7px;\n  background: white;\n}\n\n/* .closePopup {\n  color: white;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.closePopup:hover {\n  opacity: 1;\n}\n\n.closePopup:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n} */\n\n.info-card-map {\n  width: 50%;\n  left: 25%;\n  position: absolute;\n  bottom: 0;\n}\n\n.zoom-right-aligned {\n  margin-right: 32% !important;\n}\n\n.zoom-controls {\n  top: 50px !important;\n}\n\n.add-point-active {\n  cursor: crosshair;\n}\n\n.pointer-on-map {\n  cursor: pointer;\n}\n\n.popup-button {\n  background: #dddddd;\n  color: black;\n  border-radius: 6px;\n}\n\n.legend-div {\n  position: relative;\n  top: -3vh;\n}\n\n.leaflet-right .leaflet-control {\n  margin-right: 25px;\n}\n\n.leaflet-bottom .leaflet-control {\n  margin-bottom: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
